import axios from 'axios';

class PostCodeApi {
    static async searchForAddress(zipcode) {
        const postcodesAPI = axios.create({
            baseURL: 'https://postcodes.io/postcodes/'
        });

        try {
            const response = await postcodesAPI.get(`${zipcode}`);
            const result = response.data.result;

            return {
                city: result.admin_district,
                county: result.admin_county || result.region,
                country: result.country
            };
        } catch (error) {
            return { city: '', county: '', country: '', error: error.response && error.response.data.error };
        }
    }
}

export default PostCodeApi;
